import React from "react"
import { Link } from "gatsby"

import { rhythm } from "../utils/typography"
import DisqusTemplate from "../components/disqus"
import SnsButtons from "../components/sns_buttons"

class BlogArticle extends React.Component {
  isEven(num) {
    return num % 2 === 0
  }

  render() {
    const { node, idx, isIndex, siteMetadata } = this.props

    return (
      <article
        style={{
          backgroundColor: this.isEven(idx) ? "white" : "#181818",
          color: this.isEven(idx) ? "rgba(0, 0, 0, 0.8)" : "white",
        }}
      >
        <div
          style={{
            marginLeft: `auto`,
            marginRight: `auto`,
            padding: `1em calc(33% - 6.6em)`,
            fontSize: `calc(.6vw + .8em)`,
          }}
        >
          <header>
            <h2
              style={{
                marginBottom: rhythm(1 / 4),
                textAlign: `center`,
                fontSize: `1.8em`,
                border: `none`,
              }}
            >
              <Link style={{ boxShadow: `none` }} to={node.fields.slug}>
                {node.frontmatter.title}
              </Link>
            </h2>
            <div style={{ textAlign: `center`, marginBottom: `.5em` }}>
              <small>{node.frontmatter.date}</small>
            </div>
            <SnsButtons title={node.frontmatter.title} siteUrl={siteMetadata.siteUrl} slug={node.fields.slug} twitter={siteMetadata.social.twitter}/>
          </header>
          <section>
            <div
              dangerouslySetInnerHTML={{
                __html: node.html,
              }}
            />
          </section>
          <footer>
            {isIndex && (
              <p style={{ textAlign: "right" }}>
                <Link
                  id="read-more"
                  style={{
                    border: `2px solid`,
                    borderRadius: 3,
                    padding: "0.3em 0.6em",
                    transition: "background-color 0.2s ease-out",
                  }}
                  to={node.fields.slug}
                >
                  read more »
                </Link>
              </p>
            )}

            {!isIndex && (
              <>
                <p
                  style={{
                    float: `right`,
                    fontSize: `0.6em`,
                    color: `#666666`,
                  }}
                >
                  <span>categories: </span>
                  {node.frontmatter.categories.map((category, i) => (
                    <span style={{ margin: `0 5px` }} key={category}>
                      <Link
                        to={`/blog/categories/${category}`}
                        style={{ color: `rgb(0, 122, 204)` }}
                      >
                        {category}
                      </Link>
                      {node.frontmatter.categories.length - 1 > i ? "," : ""}
                    </span>
                  ))}
                </p>
                <p style={{ clear: `both` }} />
                <DisqusTemplate post={node} siteUrl={siteMetadata.siteUrl} />
              </>
            )}
          </footer>
        </div>
      </article>
    )
  }
}

export default BlogArticle
